import React from "react";

const PersonalityConfigModal = ({
  protocol,
  handleProtocolChange,
  onClose,
}) => {
  if (!protocol) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      {/* Increased width and height */}
      <div
        className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl h-[70vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4 flex-shrink-0">
          Configure Personality
        </h2>
        <div className="mb-4 flex-grow flex flex-col">
          <label
            htmlFor="personality-input"
            className="block text-sm font-medium text-gray-700 mb-1 flex-shrink-0"
          >
            Personality Description
          </label>
          <textarea
            id="personality-input"
            value={protocol.personality || ""}
            onChange={(e) =>
              handleProtocolChange("personality", e.target.value)
            }
            className="w-full h-full flex-grow p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none text-sm" // Added text-sm
            placeholder="Describe the coach's personality traits and communication style..."
          />
          <p className="text-xs text-gray-500 mt-1 flex-shrink-0">
            This description will be used in prompts like {"{personality}"}.
            Markdown is supported.
          </p>
        </div>
        <div className="flex justify-end flex-shrink-0 border-t border-gray-200 pt-4 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
          >
            Close
          </button>
          {/* No Save button needed */}
        </div>
      </div>
    </div>
  );
};

export default PersonalityConfigModal;
